import configData from '../../config.json';
import axios from 'axios';
import { Decrypt } from '../Helper';

export const GetDashboardCount = async (v) => {
    var config = {
        method: 'GET',
        url: configData.API_ENDPOINT + `counts`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}